// src/features/encounter/encounterItemSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { EncounterItemSerializer } from "@/types/encounterItem"
import { InvoiceBaseSerializer } from "@/types/invoice"
import { fetchEncounterItems } from "@core/api/encounterItemApi"

interface EncounterItemState {
  encounterItems: EncounterItemSerializer[]
  invoice: InvoiceBaseSerializer | null
  loading: boolean
  error: string | null
}

const initialState: EncounterItemState = {
  encounterItems: [],
  invoice: null,
  loading: false,
  error: null,
}

const encounterItemSlice = createSlice({
  name: "encounterItem",
  initialState,
  reducers: {
    // 전체 배열을 덮어쓰는 액션 (예: 서버에서 가져올 때)
    setEncounterItems(state, action: PayloadAction<EncounterItemSerializer[]>) {
      state.encounterItems = action.payload
    },
    // 개별 아이템을 추가하는 액션
    addEncounterItem(state, action: PayloadAction<EncounterItemSerializer>) {
      // 중복 체크: 같은 코드가 있으면 무시
      const exists = state.encounterItems.some(item => item.encounterItemCode === action.payload.encounterItemCode)
      if (!exists) {
        state.encounterItems.push(action.payload)
      }
    },
    // 특정 아이템을 제거하는 액션 (code 기준)
    removeEncounterItem(state, action: PayloadAction<{ code: string }>) {
      state.encounterItems = state.encounterItems.filter(item => item.encounterItemCode !== action.payload.code)
    },

    // 모든 아이템을 초기화할 때
    clearEncounterItems(state) {
      state.encounterItems = []
      state.invoice = null
    },
  },
  extraReducers: builder => {
    builder
      // fetchPatients 관련 처리
      .addCase(fetchEncounterItems.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchEncounterItems.fulfilled, (state, action) => {
        state.loading = false
        state.encounterItems = action.payload.items
        state.invoice = action.payload.invoice || null
      })
      .addCase(fetchEncounterItems.rejected, (state, action) => {
        state.loading = false
        state.error = (action.payload as string) || action.error.message || "알 수 없는 오류 발생"
      })
  },
})

export const { setEncounterItems, addEncounterItem, removeEncounterItem, clearEncounterItems } = encounterItemSlice.actions

export default encounterItemSlice.reducer
